import { useState } from 'react';
import { getFromStorage, removeFromStorage, setOnStorage } from '@libs/utils/helpers/handleStorage';

import { getSafeUser } from '../../helpers/getSafeUser';

import { MM_STORAGE } from './constants';
import { MatchMakerProps } from '.';

export const useMatchMaker = ({ user, token }: MatchMakerProps) => {
  const safeUser = getSafeUser(user);
  const [completedForm, setCompletedForm] = useState(getFromStorage<boolean>(MM_STORAGE.COMPLETED) || false);

  function onCompleteForm() {
    setOnStorage('session', MM_STORAGE.COMPLETED, true);
    setCompletedForm(true);
  }

  function clearForm() {
    removeFromStorage(MM_STORAGE.COMPLETED);
    setCompletedForm(false);
  }

  return {
    safeUser,
    completedForm,
    onCompleteForm,
    clearForm,
  };
};
